type FeatureFlagsState = {
  fetching: boolean
  error: any // confirm fetch response payload on error...
  data: string[]
}

export type FeatureFlagsRootState = {
  featureFlags: FeatureFlagsState
}

const initialState: FeatureFlagsState = {
  fetching: false,
  error: null,
  data: null,
}

type FeatureFlagsPending = {
  type: 'FEATURE_FLAGS_FETCH_PENDING'
}

type FeatureFlagsRejected = {
  type: 'FEATURE_FLAGS_FETCH_REJECTED'
  payload: { data: any }
}

type FeatureFlagsFulfilled = {
  type: 'FEATURE_FLAGS_FETCH_FULFILLED'
  payload: { data: string[] }
}

type FeatureFlagsAction =
  | FeatureFlagsPending
  | FeatureFlagsRejected
  | FeatureFlagsFulfilled

export default (state = initialState, action: FeatureFlagsAction) => {
  switch (action.type) {
    case 'FEATURE_FLAGS_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }
    case 'FEATURE_FLAGS_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload.data,
      }
    case 'FEATURE_FLAGS_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        data: action.payload.data,
      }
    default:
      return state
  }
}
